const { isEmpty, isFunction } = require('lodash');
const { match } = require('path-to-regexp');
const pageRouterConfig = require('./pageRouterConfig');

const fetchPageInfo = (pathname, params) => {
  const requestConfig = getConfigForUrl(pathname);
  const requestParams = params;
  if (!requestConfig) {
    return getDefaultPageInfo(pathname);
  }
  const pageTrackingInfo = buildTargetPageForConfig(requestConfig, requestParams, pathname);
  pageTrackingInfo.website_version = process.env.WEBSITE_VERSION || 'local';
  return pageTrackingInfo;
};

const getConfigForUrl = pathname => {
  // loop through configs

  const requestConfig = processRoutingLogicforPath(pageRouterConfig, pathname);
  return isEmpty(requestConfig.config) ? null : requestConfig;
};

const getDefaultPageInfo = pathname => ({
  path: pathname,
  page_type: pathname,
  entity_id: null,
});

const buildTargetPageForConfig = (requestConfig, requestParams, pathname) => {
  // check type of the config page
  const configTargetPageInfo = requestConfig.config.pageInfo;
  // check if pageInfo is not present
  if (!configTargetPageInfo) {
    return getDefaultPageInfo(pathname);
  }
  // check if it is a function
  if (isFunction(configTargetPageInfo)) {
    // call function with params
    const targetPageInfo = configTargetPageInfo.call(null, pathname, requestConfig.pathParams, requestParams);
    // check if the return type has value
    if (!targetPageInfo) {
      return getDefaultPageInfo(pathname);
    }

    return targetPageInfo;
  }

  // not a function we will send back original request path
  return getDefaultPageInfo(pathname);
};

const processRoutingLogicforPath = (filteredConfig, pathname) => {
  // loop through configs
  const requestConfig = {
    config: {},
    pathParams: {},
  };

  filteredConfig.some(config => {
    // validate with match
    const pathMatch = match(config.path, { decode: decodeURIComponent });
    const requestMatch = pathMatch(pathname);

    if (requestMatch) {
      requestConfig.config = config;
      requestConfig.pathParams = requestMatch.params;
      return requestConfig;
    }

    return null;
  });

  return requestConfig;
};

module.exports = fetchPageInfo;
